module.exports = __webpack_public_path__ + "img/logo4.34d0c2fb.png";